'use client';

import React, { useRef, useState } from 'react';
import { PlayButton } from './components/PlayButton';
import { VideoElement } from './components/VideoElement';
import { cn } from '@/utils/cva';
import type { IVideoPlayerProps } from './VideoPlayer.types';
import { videoPlayerVariants } from './VideoPlayer.styles';

const VideoPlayer: React.FC<IVideoPlayerProps> = ({
  src,
  poster,
  classNames,
  size,
  rounded,
  aspect,
  onPlay,
  onPause,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const togglePlay = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play().then(() => {
        setIsPlaying(true);
        onPlay?.();
      });
    }
  };

  return (
    <div
      className={cn(
        videoPlayerVariants({ size, rounded, aspect }),
        classNames?.videoPlayer
      )}
    >
      <VideoElement
        classNames={{ video: classNames?.video }}
        poster={poster}
        setIsPlaying={setIsPlaying}
        src={src}
        videoRef={videoRef}
        onPause={onPause}
        onPlay={onPlay}
      />
      {!isPlaying && (
        <PlayButton className={classNames?.playButton} onClick={togglePlay} />
      )}
    </div>
  );
};

export default VideoPlayer;
export { VideoPlayer, type IVideoPlayerProps };
